import { EventTracking } from "@shared/services/event_tracking/events";
import { SalesRepsEventEntity } from "@shared/services/event_tracking/entities";
import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
import { get } from "svelte/store";
import * as _ from 'lodash';

const { trackEvent } = EventTracking;

var service = function(CachedRequest, Flash, $q) {
  var cachedRes = function() {
    return {
      get: function() {
        return cachedRes;
      },
      load: function() {
        return CachedRequest({
          method: 'GET',
          url: '/api/retailer/distributors',
          params: {
            with_cutoff_time: true,
            with_domains: true,
            with_integrated: true,
            with_sales_reps: true,
          }
        }).then(function(res) {
          if (!get(DistributorsStore).length) {
            DistributorsStore.set(res.data);
          }

          cachedRes = {};
          _.map(res.data, function(i) {
            cachedRes[i.id] = i;
          });
          return cachedRes;
        });
      },
    };
  };

  var submit = function(distributor, reps, errorCallback) {
    return $http({
      method: 'POST',
      url: '/api/retailer/distributors/' + distributor.id + '/sales_rep_assignments/replace',
      data: {
        replace: {
          sales_rep_ids: _.map(reps, function(x) { return x.id; })
        }
      }
    }).then(function success(res) {
      let header = "", msg = "";
      let repsUpdatedMessage = (reps) => {
        let addedMessage = "";
        let removedMessage = "";
        if (reps.added.length > 0) addedMessage = `${reps.added.join(', ')} added to ${distributor.name}. `;
        if (reps.removed.length > 0) removedMessage = `${reps.removed.join(', ')} removed from ${distributor.name}.`;
        return addedMessage + removedMessage;
      }

      DistributorsStore.pushAddedSalesReps(distributor.id, reps);

      if (!distributor.sales_reps || distributor.sales_reps.length == 0) {
        header = 'Distributor connected';
        if (window.location.pathname == "/settings/accounts") {
          if (res.data.added && res.data.added.length === 0) {
            window['stateService'].reload();
            return;
          }
          msg = `You can now place orders with ${distributor.name}.`
        } else {
          msg = `You can now place orders with ${distributor.name}. Manage your sales reps in Settings → My Distributors`;
        }
      } else {
        msg = repsUpdatedMessage(res.data);
        header = 'Sales reps updated';
       trackEvent(
          'Sales Reps Added',
          new SalesRepsEventEntity({service: 'Retailer', component: 'Distributor Settings', ids: distributor.sales_reps.map(rep => rep.id)})
        );
      }

      if (window['modern_mode']) {
        Flash.setMessage(msg, true, 'notice', header);
        window['stateService'].reload();
      } else {
        Flash.setMessage(msg, false, 'notice', header);
        window['stateService'].reload();
      }
    }, function error(res) {
      errorCallback(res);
    });
  }

  var addNewSalesRep = function(distributor, newRep, errorCallback) {
    return $http({
      method: 'POST',
      url: '/api/retailer/distributors/' + distributor.id + '/sales_reps',
      data: {
        sales_rep: {
          name: newRep.name,
          contact_phone: newRep.contact_phone,
          contact_email: newRep.contact_email,
          skip_assignment: true
        }
      }
    }).then(function success(res) {
      if (!_.get(res, 'data.id')) {
        Flash.setMessage('Sorry - we had a problem. Please try again or contact support.', true, 'error');
        let error = new Promise((resolve) => resolve({error: 'Could not create rep.'}));
        return error;
      }
     trackEvent(
        'Sales Reps Added',
        new SalesRepsEventEntity({service: 'Retailer', component: 'Distributor Settings New Sales Rep', id: res.data.id})
      );
      return new Promise((resolve) => resolve(res));
    }, function error(res) {
      return errorCallback(res);
    })
  }

  var removeDistributor = function(distributor, cb) {
    $http({
      method: 'POST',
      url: `api/retailer/retailer_distributors/destroy`,
      data: {
        retailer_distributor: {
          distributor_id: distributor.id
        }
      }
    }).then(function success(res) {
      if (cb) { cb(res); }
    }, function error(res) {
      Flash.setMessage(`Sorry - we had a problem disconnecting ${distributor.name}. If you contact support we would be happy to help you.`, true, 'error');
    })
  }

  var updateDefaultDistributor = function(productTypeId, spiritsDefaultedDistributorId, successCallback, errorCallback) {
    $http({
      method: "POST",
      url: "api/retailer/default_distributor",
      data: {
        product_type_id: productTypeId,
        distributor_id: spiritsDefaultedDistributorId,
      }
    }).then(function success(res) {
      successCallback(productTypeId, spiritsDefaultedDistributorId);
      window['stateService'].reload();
    }, function error(res) {
      errorCallback(res);
    });
  }

  return {
    cachedRes,
    submit,
    addNewSalesRep,
    removeDistributor,
    updateDefaultDistributor,
  };
};

service.$inject = ['CachedRequest', 'Flash', '$q'];

tiz.service('Distributors', service);

export default service;
